import { Injectable } from '@angular/core';

@Injectable()
export class AppDataBroker {
    AppData:          any;
    AppMenuViewModel: any;

    constructor() {
        console.log('initialising app data service');
    }

    public SetAppData(pAppData: any): void {
        this.AppData = pAppData;
    }

    public GetAppData(): any {
        return this.AppData;
    }

    public SetAppMenuViewModel(pAppMenuViewModel: any): void {
        this.AppMenuViewModel = pAppMenuViewModel;
    }

    public GetAppMenuViewModel(): any {
        return this.AppMenuViewModel;
    }
}


// WEBPACK FOOTER //
// ./src/services/AppData.ts